import * as React from "react";
import { Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import type { DocumentChronology } from "@/types/chronology";

interface Props {
  documentChronology: DocumentChronology;
}
export const ChronologyListActionsExport: React.FC<Props> = ({ documentChronology }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button variant="default" size="sm" className="w-full text-xs sm:w-auto">
        <Download className="mr-2 h-4 w-4" />
        Export
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem>
        <a target="_blank" href={`/pf-document/chronologies/fse-chronology-export/${documentChronology.fse_id}`}>
          Export to XLS
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
